import { render, staticRenderFns } from "./illegalBuilding.vue?vue&type=template&id=0baa77f9&scoped=true&"
import script from "./illegalBuilding.vue?vue&type=script&lang=js&"
export * from "./illegalBuilding.vue?vue&type=script&lang=js&"
import style0 from "./illegalBuilding.vue?vue&type=style&index=0&id=0baa77f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa77f9",
  null
  
)

export default component.exports